import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EssayCandidateModel, MarkingQuestionModel, IExam, AdjustQuestionScoreModel, EssayCandidateResponseModel } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ScoreAdjustmentModalComponent } from '../../Shared/score-adjustment-modal/score-adjustment-modal.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-mark-essay',
  templateUrl: './mark-essay.component.html',
  styleUrls: ['./mark-essay.component.scss'],
})
export class MarkEssayComponent implements OnInit {
  mode: string = 'mark';
  candidates: EssayCandidateModel[] = [];
  questions: MarkingQuestionModel[] = [];
  pickedQuestion: MarkingQuestionModel;
  selectedCandidate: EssayCandidateModel;
  totalScore: number;
  examination: IExam;
  candidateCount: number;

  constructor(
    private snackBar: SnackbarService,
    private examService: ExamService,
    private examSchService: ExamScheduleService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private confirmDialog: ConfirmDialogService, 
    public sanitizer: DomSanitizer
  ) {}

  get totalMarkedCandidates() {
    return this.candidates.filter((cand) => cand.marked).length;
  }
  get totalUnMarkedCandidates() {
    return this.candidates.filter((cand) => !cand.marked).length;
  }
  get totalCandidatesReviewed() {
    return this.candidates.filter((cand) => cand.reviewed).length;
  }
  get totalCandidatesPending() {
    return this.candidates.filter((cand) => !cand.reviewed).length;
  }

  get totalScheduleEssaySubQuestionScores(): number {
    if (!this.pickedQuestion?.hasEssaySubQuestions || !this.pickedQuestion?.scheduleEssaySubQuestions) {
      return 0;
    }

    return this.pickedQuestion.scheduleEssaySubQuestions
      .map((sQuestion) => Number(sQuestion.essayMarkEarned) || 0)
      .reduce((a, b) => a + b, 0);
  }

  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = params['mode'] || 'mark';
    });

    let selectedExamID = this.examService.selectedExamIds[0];
    this.examination = this.examService.selectedExams[0];
    let selectedSchID =
      (this.examSchService.selectedIds && this.examSchService.selectedIds[0]) ??
      0;
    let data = {
      ExaminationScheduleID: selectedSchID,
      ExaminationID: selectedExamID,
      Mode: this.mode,
    };

    const response = (await this.examService.getEssayCandidate(
      data
    )) as EssayCandidateResponseModel;
    this.candidates = response.essayCandidates;
    this.candidateCount = response.candidateCount;
  }

  async loadAllQuestions(cand: EssayCandidateModel) {
    this.questions = [];
    this.pickedQuestion = null;
    this.selectedCandidate = cand;
    let data = {
      ExaminationID: this.examination.id,
      ExaminationScheduleID: cand.examinationScheduleID,
      Mode: this.mode,
    };

    const buttons = document.querySelectorAll('.canlist');
    buttons.forEach((button) => {
      button.classList.remove('btn-warning');
    });
    const activeButton = document.getElementById(cand.examNo.toString());
    if (activeButton) {
      activeButton.classList.add('btn-warning');
    }

    this.questions = (await this.examService.getMarkEssayQuestions(
      data
    )) as any[];
    if (this.questions.length > 0) {
      this.loadQuestion(this.questions[0].esqId);
    }
  }

  loadQuestion(id) {
    this.pickedQuestion = this.questions.find((x) => x.esqId == id);
    this.calculateTotalScore();
  }

  hasNextQuestion() {
    if (!this.questions || this.questions.length === 0) {
      return false;
    }
    const currentIndex = this.questions.findIndex(
      (q) => q.esqId === this.pickedQuestion.esqId
    );
    return currentIndex < this.questions.length - 1;
  }

  hasPreviousQuestion() {
    if (!this.questions || this.questions.length === 0) {
      return false;
    }
    const currentIndex = this.questions.findIndex(
      (q) => q.esqId === this.pickedQuestion.esqId
    );
    return currentIndex > 0;
  }

  nextQuestion() {
    const currentIndex = this.questions.findIndex(
      (q) => q.esqId === this.pickedQuestion.esqId
    );
    if (currentIndex < this.questions.length - 1) {
      this.loadQuestion(this.questions[currentIndex + 1].esqId);
    }
  }
  previousQuestion() {
    const currentIndex = this.questions.findIndex(
      (q) => q.esqId === this.pickedQuestion.esqId
    );
    if (currentIndex > 0) {
      this.loadQuestion(this.questions[currentIndex - 1].esqId);
    }
  }

  calculateTotalScore() {
    this.totalScore = this.questions.reduce(
      (acc, q) => acc + (q.essayMarkEarned || 0),
      0
    );
  }

  async markEssay() {
    const currentIndex = this.questions.findIndex(
      (q) => q.esqId === this.pickedQuestion.esqId
    );

    if (this.pickedQuestion.scheduleEssaySubQuestions) {
         // Validate that all sub question have scores
      const invalidSubQuestions = this.pickedQuestion.scheduleEssaySubQuestions.filter(
        sQuestion => sQuestion.essayMarkEarned === null || sQuestion.essayMarkEarned === undefined
      );

      if (invalidSubQuestions.length > 0) {
        this.snackBar.error('Please enter scores for all sub-question');
        return;
      }

      const overScoredSubQuestions = this.pickedQuestion.scheduleEssaySubQuestions.filter(
    sQuestion => sQuestion.essayMarkEarned > sQuestion.marks
  );

  if (overScoredSubQuestions.length > 0) {
    const labels = overScoredSubQuestions
      .map(sQuestion => sQuestion.questionNoLabel || '?')
      .join(', ');
    this.snackBar.error(`Scores for sub-question(s) ${labels} exceed their maximum marks`);
    return;
  }

      const sectionTotal = this.totalScheduleEssaySubQuestionScores;

      if (sectionTotal > this.pickedQuestion.mark) {
        this.snackBar.error('Total section scores exceed the maximum mark');
        return;
      }

      // Update the total score for the question based on section scores
      this.pickedQuestion.essayMarkEarned = sectionTotal;
    } else {
      if (
        this.pickedQuestion.essayMarkEarned === null ||
        this.pickedQuestion.essayMarkEarned === undefined
      ) {
        this.snackBar.error('Please enter a score');
        return;
      }

      if (this.pickedQuestion.essayMarkEarned > this.pickedQuestion.mark) {
        this.snackBar.error(
          'Score should be less than or equal to total marks'
        );
        return;
      }
    }

    this.questions[currentIndex].essayMarkEarned =
      this.pickedQuestion.essayMarkEarned;
    this.questions[currentIndex].scheduleEssaySubQuestions =
      this.pickedQuestion.scheduleEssaySubQuestions;

    this.examService.markEssayQuestion(this.pickedQuestion).then(() => {
      this.snackBar.success('Scored Successfully');
    });
    this.calculateTotalScore();
  }

  openAdjustScoreModal() {
    const modalRef = this.modalService.open(ScoreAdjustmentModalComponent, {
      centered: true,
      scrollable: true,
    });

    modalRef.componentInstance.currentScore =
      this.pickedQuestion.essayMarkEarned;
    modalRef.componentInstance.maxScore = this.pickedQuestion.mark;
    modalRef.componentInstance.questionNo = this.pickedQuestion.questionNo;
    modalRef.componentInstance.questionId = this.pickedQuestion.esqId;
    modalRef.componentInstance.examinationType = 'Essay';
    modalRef.componentInstance.scheduleEssaySubQuestions =
      this.pickedQuestion.scheduleEssaySubQuestions;
    modalRef.componentInstance.hasessaysubquestions =
      this.pickedQuestion.hasEssaySubQuestions;

    modalRef.result.then(
      (result: AdjustQuestionScoreModel) => {
        if (result) {
          if (
            !this.pickedQuestion.hasEssaySubQuestions &&
            result.adjustedScore === this.pickedQuestion.essayMarkEarned
          ) {
            this.snackBar.warning(
              'No adjustment applied since the current score matches the adjusted score.'
            );
            return;
          }
          this.adjustScore(result);
        }
      },
      (reason) => {
        // Modal dismissed
      }
    );
  }

  async adjustScore(adjustmentData: AdjustQuestionScoreModel) {
    try {
      await this.examService.adjustQuestionScore(adjustmentData);
      const currentIndex = this.questions.findIndex(
        (q) => q.esqId === adjustmentData.esqId
      );
      if (currentIndex !== -1) {
        if (
          this.pickedQuestion.hasEssaySubQuestions &&
          adjustmentData.scheduleEssaySubQuestions 
        ) {
        
         adjustmentData.scheduleEssaySubQuestions.forEach((adjustedSubQuestion, index) => {
          if (this.questions[currentIndex].scheduleEssaySubQuestions[index]) {
            this.questions[currentIndex].scheduleEssaySubQuestions[index].essayMarkEarned = 
              adjustedSubQuestion.essayMarkEarned;
          }
        });
        
        this.questions[currentIndex].essayMarkEarned =
             this.questions[currentIndex].scheduleEssaySubQuestions.reduce(
              (sum, sQuestion) => sum + (sQuestion.essayMarkEarned || 0),
              0
            );

          this.loadQuestion(this.questions[currentIndex].esqId);
        } else {
          this.questions[currentIndex].essayMarkEarned =
            adjustmentData.adjustedScore;
        }

        const index = this.candidates.findIndex(
          (c) => c.examNo === this.selectedCandidate.examNo
        );
        if (index !== -1) {
          this.candidates[index].reviewed = false;
        }
        this.calculateTotalScore();
      }

      this.snackBar.success('Score adjusted successfully');
    } catch (error) {
      this.snackBar.error('Failed to adjust score');
    }
  }

  hasNextCandidate() {
    if (
      !this.candidates ||
      this.candidates.length === 0 ||
      !this.selectedCandidate
    ) {
      return false;
    }
    const currentIndex = this.candidates.findIndex(
      (c) => c.examNo === this.selectedCandidate.examNo
    );
    return currentIndex < this.candidates.length - 1;
  }

  hasPreviousCandidate() {
    if (
      !this.candidates ||
      this.candidates.length === 0 ||
      !this.selectedCandidate
    ) {
      return false;
    }
    const currentIndex = this.candidates.findIndex(
      (c) => c.examNo === this.selectedCandidate.examNo
    );
    return currentIndex > 0;
  }

  nextCandidate() {
    if (!this.hasNextCandidate()) {
      return;
    }

    const currentIndex = this.candidates.findIndex(
      (c) => c.examNo === this.selectedCandidate.examNo
    );

    if (!this.candidates[currentIndex].marked && this.mode === 'mark') {
      this.snackBar.success('Ensure to submit once grading is done');
    }

    const nextCandidate = this.candidates[currentIndex + 1];
    this.loadAllQuestions(nextCandidate);
  }

  previousCandidate() {
    if (!this.hasPreviousCandidate()) {
      return;
    }

    const currentIndex = this.candidates.findIndex(
      (c) => c.examNo === this.selectedCandidate.examNo
    );
    const prevCandidate = this.candidates[currentIndex - 1];
    this.loadAllQuestions(prevCandidate);
  }

  async openSubmitConfirmation(event: MouseEvent) {
    if (!this.selectedCandidate) {
      this.snackBar.error('Please select a candidate first');
      return;
    }

    const confirmed = await this.confirmDialog.open({
      message:
        'Are you sure you want to submit marks for this candidate? Submitting means essay scores cannot be updated afterward.',
      confirmText: 'Yes, Submit',
      cancelText: 'Cancel',
      size: 'lg',
      centered: false,
      title: 'Confirm Submission',
    });

    if (confirmed) {
      this.submitCandidateMarks();
    }
  }

  async submitCandidateMarks() {
    try {
      await this.examService.setEssayAsMarked(
        this.examService.selectedExamIds[0],
        this.selectedCandidate.examinationScheduleID
      );

      const index = this.candidates.findIndex(
        (c) => c.examNo === this.selectedCandidate.examNo
      );
      if (index !== -1) {
        this.candidates[index].marked = true;
      }

      this.snackBar.success('Candidate scores submitted successfully');
    } catch (error) {
      this.snackBar.error('Failed to submit candidate marks');
    }
  }

  isReadOnly(): boolean {
    return (
      this.mode === 'review' ||
      (this.mode === 'mark' && this.selectedCandidate?.marked)
    );
  }

  async SetAsReviewed() {
    try {
      const response = (await this.examService.setAsReviewed(
        this.examService.selectedExamIds[0],
        this.selectedCandidate.examinationScheduleID
      )) as any;

      const index = this.candidates.findIndex(
        (c) => c.examNo === this.selectedCandidate.examNo
      );
      if (index !== -1) {
        this.candidates[index].reviewed = true;
        this.candidates[index].reviewer = String(response.data);
      }

      this.snackBar.success('Marked as review successfully');
    } catch (error) {
      this.snackBar.error('Failed to set as Reviewed');
    }
  }
}
